import React from 'react'

const FibaseContext = React.createContext();

export default FibaseContext;